import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";
import {
  DirectionsBoat,
  People,
  Work,
  Groups,
  BusinessCenter,
  AssignmentTurnedIn,
} from "@mui/icons-material";
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

import baseURL from "../config";
import Navbar from "../Navbar/Navbar";

const AdminDashboard = () => {
  const navigate = useNavigate(); // Navigation Hook

  const [dashboardData, setDashboardData] = useState({
    VesselOwners: 0,
    Crew: 0,
    Vessel: 0,
    CrewingAgents: 0,
    Contracts: 0,
    Chartered: 0,
    veesselOwnerRefundRequest: 0,
  });

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      setIsLoading(true);
      const token = localStorage.getItem("token");

      if (!token) {
        alert("Session expired. Redirecting to login.");
        localStorage.removeItem("token");
        window.location.href = "/login";
        return;
      }

      const config = { headers: { Authorization: `Bearer ${token}` } };

      try {
        const response = await axios.get(`${baseURL}/api/getTotalCounts`, config);
        

        setDashboardData({
          VesselOwners: response.data?.vesselOwnerCount || 0,
          VesselManagers: response.data?.vesselCount || 0,
          Crew: response.data?.crewCount || 0,
          Vessel: response.data?.vesselCount || 0,
          CrewingAgents: response.data?.crewingAgentCount || 0,
          Contracts: response.data?.contractCount || 0,
        });
      } catch (error) {
        console.error("Error fetching total counts:", error);
        if (error.response?.status === 401) {
          alert("Session expired. Redirecting to login.");
          localStorage.removeItem("token");
          window.location.href = "/login";
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  const cardData = [
    { icon: <DirectionsBoat fontSize="large" />, value: dashboardData.VesselOwners, label: "Vessel Owners" , path: "/vessel_owner_table" },
    { icon: <Work fontSize="large" />, value: dashboardData.Vessel, label: "Vessels", path:"/vessel_Table"},
    { icon: <Groups fontSize="large" />, value: dashboardData.Crew, label: "Crews" , path: "/CrewProfileTable" },
    { icon: <BusinessCenter fontSize="large" />, value: dashboardData.CrewingAgents, label: "Crewing Agents", path: "/AllAdminCrewing" }, 
    { icon: <AssignmentTurnedIn fontSize="large" />, value: dashboardData.Contracts, label: "Contracts", path: "/AllAdminContract" },
    { icon: <AssignmentTurnedIn fontSize="large" />, value: dashboardData.Chartered, label: "Chartered" , path: "/CharteredVessel"},
    { icon: <RequestQuoteIcon fontSize="large" />, value: dashboardData.veesselOwnerRefundRequest, label: "Vessel Owner Refund Requests", path: "/VesselOwnerRefundRequests" },
  ];

  return (
    <>
      <Navbar />
      <Box sx={{ p: 3, bgcolor: "grey.100", minHeight: "100vh" }}>
        <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
          Overview
        </Typography>

        <Grid container spacing={3}>
          {cardData.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  textAlign: "center",
                  borderRadius: 3,
                  border: "1px solid",
                  borderColor: "grey.300",
                  transition: "all 0.3s",
                  "&:hover": { boxShadow: 6 },
                  cursor: item.path ? "pointer" : "default", // Make clickable only if path exists
                }}
                onClick={() => item.path && navigate(item.path)} // Navigate on click
              >
                <Box sx={{ display: "flex", justifyContent: "center", color: "#C30B12", mb: 1 }}>
                  {item.icon}
                </Box>
                <Typography variant="h4" fontWeight="bold">
                  {item.value}
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  {item.label}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default AdminDashboard;
